import React from "react";
import { Parallax } from "react-parallax";
import { appleAppStoreLink, googlePlayStoreLink } from "../config/commonConfig";

function GetTheApp() {
  return (
""
  );
}

export default GetTheApp;
